import React, { useEffect, useRef, useState } from "react";
import { ringImages } from "../data/landing";
export function PreviewRing() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver(en => setVisible(en[0].isIntersecting), {
      rootMargin: "120px"
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const step = 360 / ringImages.length;
  return <div className="pv" data-id="element-130" data-mp="3r1zp67f82df5">
      <div className="pvh" data-id="element-131" data-mp="3r2sx3bpx38yv">
        <i data-id="element-132" data-mp="9sujvwtrtrud">✦</i>
        <span data-id="element-133" data-mp="9tcll8z7cy9o">Uma espiada dentro da coleção</span>
      </div>
      <div className="pvs" data-id="element-134" data-mp="4t869ma169l1">
        <div className="pvr" ref={ref} style={{
        animationPlayState: visible ? "running" : "paused"
      }} data-id="element-135" data-mp="4synainel2ou">
          {ringImages.map((img, i) => <div className="pvc" key={img.src} style={{
          transform: `rotateY(${(i * step).toFixed(2)}deg) translateZ(170px)`
        }} data-id="element-136" data-mp="1l9ktzr1bf3t9" data-mpi={i}>
              <img src={img.src} alt={img.alt} loading="lazy" data-id="element-137" data-mp="3dvtrkc3dyk5j" />
            </div>)}
        </div>
      </div>
      <p className="pvp" data-id="element-138" data-mp="3itvamx0tajh0">7 das 893 páginas · fichas reais dos tomos e bônus</p>
    </div>;
}